import { type FC } from 'react';
import ListingFilterSelect from './ListingFilterSelect';
import ListingFilterInput from './ListingFilterInput';
import { type Filter, type ListingFiltersState } from './ListingFiltersTypes';
import { generateYearRangeItems } from './ListingFilterHelpers';


export interface ListingFiltersProps extends ListingFiltersState {
    filters: Filter[]; // settings
    disabled?: boolean;
    hasSearchFilterOnly?: boolean;
}

const ListingFilters: FC<ListingFiltersProps> = ({ filters, activeFilters, setActiveFilters, disabled, hasSearchFilterOnly }) => {
    // Use single column layout when we have search filter only
    const columnClass = hasSearchFilterOnly ? 'cols-1' : `cols-${filters.length}`;

    return (
        <div className={`listing-app-filter ${columnClass} ${hasSearchFilterOnly ? 'has-search-filter-only' : ''}`}>
            {filters.map(({ placeholder, field, items, type, start, end }) => {
                const key = `${placeholder}-${field}`;

                switch (type) {
                case 'input': {
                    return (
                        <ListingFilterInput
                            key={key}
                            placeholder={placeholder}
                            field={field}
                            activeFilters={activeFilters}
                            setActiveFilters={setActiveFilters}
                            disabled={disabled}
                            suffixIcon="search"
                            maxLength={30}
                        />
                    );
                }
                case 'year-select': {
                    const startYear = start || 1960;
                    const yearItems = generateYearRangeItems(startYear, end);

                    return (
                        <ListingFilterSelect
                            key={key}
                            placeholder={placeholder}
                            field={field}
                            activeFilters={activeFilters}
                            setActiveFilters={setActiveFilters}
                            items={yearItems || []}
                            disabled={disabled}
                        />
                    );
                }
                // default to 'select'
                default: {
                    return (
                        <ListingFilterSelect
                            key={key}
                            placeholder={placeholder}
                            field={field}
                            activeFilters={activeFilters}
                            setActiveFilters={setActiveFilters}
                            items={items || []}
                            disabled={disabled}
                        />
                    );
                }
                }
            })}
        </div>
    );
};

export default ListingFilters;
